// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-title{color:#000;font-family:\"Nunito Sans\";font-size:18px;font-style:normal;font-weight:800;line-height:28px}.cookies-btn{display:inline-flex;padding:12px 24px;justify-content:center;align-items:center;gap:8px;border-radius:4px}.accept-cookies-btn{background:#24252a;color:#fff}.decline-cookies-btn{background:#f0f2f4}.cookie-title~p{font-family:\"Nunito Sans\";font-size:15px;font-weight:400;line-height:24px;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
